import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiSummaryIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "8 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		"data-figma-bg-blur-radius": 4.9495,
		children: [/* @__PURE__ */ _jsx("rect", {
			x: 8.66113,
			width: 28,
			height: 28,
			rx: 6.22222,
			fill: "white",
			fillOpacity: .05
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_31180_23765)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5615 18.0997L13.3968 16.1966C13.2544 16.144 13.1315 16.0491 13.0447 15.9245C12.9579 15.8 12.9114 15.6518 12.9114 15.5C12.9114 15.3482 12.9579 15.2001 13.0447 15.0755C13.1315 14.951 13.2544 14.856 13.3968 14.8034L18.5615 12.9003L20.4646 7.73563C20.5171 7.59322 20.6121 7.47035 20.7366 7.38356C20.8612 7.29677 21.0093 7.25024 21.1611 7.25024C21.3129 7.25024 21.4611 7.29677 21.5856 7.38356C21.7102 7.47035 21.8051 7.59322 21.8577 7.73563L23.7608 12.9003L28.9255 14.8034C29.0679 14.856 29.1908 14.951 29.2776 15.0755C29.3644 15.2001 29.4109 15.3482 29.4109 15.5C29.4109 15.6518 29.3644 15.8 29.2776 15.9245C29.1908 16.0491 29.0679 16.144 28.9255 16.1966L23.7608 18.0997L21.8577 23.2644C21.8051 23.4068 21.7102 23.5297 21.5856 23.6165C21.4611 23.7032 21.3129 23.7498 21.1611 23.7498C21.0093 23.7498 20.8612 23.7032 20.7366 23.6165C20.6121 23.5297 20.5171 23.4068 20.4646 23.2644L18.5615 18.0997Z",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27.1611 3.5V8",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M31.6611 8.75V11.75",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M24.9111 5.75H29.4111",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.1611 10.25H33.1611",
					stroke: "currentColor",
					strokeWidth: 1.5,
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "bgblur_0_31180_23765_clip_path",
		transform: "translate(0 0)",
		children: /* @__PURE__ */ _jsx("rect", {
			x: 8.66113,
			width: 28,
			height: 28,
			rx: 6.22222
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_31180_23765",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(10.6611 2)"
		})
	})] })]
});
export default SvgAiSummaryIcon;
